import Net from './Net';
import ApiRouter from './ApiRouter';
import { httpGet, httpPost } from "./Net";

export default class Api {

  /**
   * 获取话题详情
   */
  static getCommunityDetail(reviewId) {
    var params = new Object()
    // params.reviewId = reviewId
    // params.uid = ''
    let url = ApiRouter.getCommunityDetail + reviewId
    return httpGet(url, { data: params })
  }

  /**
  *  获取文章详情
  */
  static getBlogCommentList(reviewId) {
    var params = new Object()
    params.id = reviewId
    params.page = 1
    params.limit = 50
    return httpGet(ApiRouter.blogCommentList, { data: params })
  }

  static deviceInfo(params) {
    return httpPost(ApiRouter.deviceInfo, { data: params })
  }

  static shareInfo() {
    return httpGet(ApiRouter.shareInfo)
  }
}




// WEBPACK FOOTER //
// ./src/network/Api.js